import clsx from 'clsx';

import { LITERACY_INSIGHT_DATA_TYPE } from './constants';

export const patchHTMLWithLinks = (
  htmlString: string,
  linkClassnames?: string,
  iconClassnames?: string,
) => {
  return htmlString
    .replaceAll(
      '<a',
      `<a class="${clsx(
        linkClassnames,
      )}" target="_blank" data-type="${LITERACY_INSIGHT_DATA_TYPE}"`,
    )
    .replaceAll(
      '</a>',
      `<i class="icon-v2-new-tab ${clsx(
        iconClassnames,
      )}" data-testid="literacy-insight-new-tab-icon" aria-hidden="true"></i></a>`,
    );
};
